import { render, staticRenderFns } from "./IlluContact.vue?vue&type=template&id=a60d4cc0&"
import script from "./IlluContact.vue?vue&type=script&lang=js&"
export * from "./IlluContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports